// Toggle Service form
var show = function (elem) {
	elem.classList.add('is-visible');
};

var hide = function (elem) {
	elem.classList.remove('is-visible');
};

var toggle = function (elem) {
	elem.classList.toggle('is-visible');
};

document.addEventListener('click', function (event) {

	if (!event.target.classList.contains('toggle')) return;

	event.preventDefault();

	var content = document.querySelector(event.target.hash);
	if (!content) return;

	toggle(content);

}, false);


// WEBPACK FOOTER //
// src/assets/index.js